// initial state
import * as base from './base.js'
const baseName = '/admin/api/payment'

const obj = base.setBaseUrl('payment', baseName)
const a = Object.assign(obj)
export default a
